(function () {
  const FLAG = '__sparkAddOnSyncInit';
  // @ts-ignore
  if (window[FLAG]) return;
  // @ts-ignore
  window[FLAG] = true;

  const SPARK_SELECTOR = 'spark-pdp';
  const BUTTON_SELECTOR = '.button-purchase button';
  const QUANTITY_INPUT_SELECTOR = '.spark-table-legacy-td.quantity-select input[type="number"]';
  const DEFAULT_CUSTOM_COLOR_SKU = 'Custom Color Option';
  const DEFAULT_WARRANTY_SKU = 'Dealer Lifetime Torsion Warranty';

  const queue = {
    tasks: [],
    processing: false,
    async add(task) {
      this.tasks.push(task);
      if (!this.processing) {
        this.process();
      }
    },
    async process() {
      if (this.processing || this.tasks.length === 0) return;
      this.processing = true;
      while (this.tasks.length > 0) {
        const task = this.tasks.shift();
        if (task) {
          try {
            await task();
          } catch (error) {}
        }
      }
      this.processing = false;
    },
  };

  const state = {
    observersStarted: false,
    customColorSku: null,
    warrantySku: null,
    previousCartProducts: null,
    initialized: false,
  };

  const CHECKOUT_BUTTON_FALLBACK_MS = 5000;
  const CHECKOUT_REAPPLY_DISABLE_MS = 250;
  let checkoutReenableFallbackTimeout = null;
  let checkoutDisabledForCcoSync = false;

  const getCheckoutButton = () => {
    return (
      document.getElementById('checkout') ||
      document.querySelector('button[name="checkout"][form="cart-form"]') ||
      document.querySelector('.cart__checkout-button')
    );
  };

  const disableCheckoutButton = () => {
    checkoutDisabledForCcoSync = true;
    const btn = getCheckoutButton();
    if (btn) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
    }
  };

  const reenableCheckoutButton = () => {
    checkoutDisabledForCcoSync = false;
    if (checkoutReenableFallbackTimeout) {
      clearTimeout(checkoutReenableFallbackTimeout);
      checkoutReenableFallbackTimeout = null;
    }
    const btn = getCheckoutButton();
    if (btn) {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
    }
  };

  const scheduleCheckoutReenableFallback = () => {
    if (checkoutReenableFallbackTimeout) {
      clearTimeout(checkoutReenableFallbackTimeout);
    }
    checkoutReenableFallbackTimeout = setTimeout(() => {
      checkoutReenableFallbackTimeout = null;
      checkoutDisabledForCcoSync = false;
      reenableCheckoutButton();
    }, CHECKOUT_BUTTON_FALLBACK_MS);
  };

  const getGlobalSkuFallback = (key, defaultValue) => {
    // @ts-ignore
    const config = window.sparkAddOnSkuConfig || {};
    return (key && config[key]) || defaultValue;
  };

  const getCustomColorSku = () => {
    if (state.customColorSku) return state.customColorSku;
    const productForm = document.querySelector('product-form-component');
    const customColorElement = document.querySelector('.custom-color-option');
    const sku =
      customColorElement?.dataset?.hiddenVariantSku ||
      productForm?.dataset?.customColorSku ||
      getGlobalSkuFallback('customColor', DEFAULT_CUSTOM_COLOR_SKU);
    state.customColorSku = sku;
    return sku;
  };

  const getWarrantySku = () => {
    if (state.warrantySku) return state.warrantySku;
    const productForm = document.querySelector('product-form-component');
    const warrantyElement = document.querySelector('.warranty-option');
    const sku =
      warrantyElement?.dataset?.warrantySku ||
      productForm?.dataset?.warrantySku ||
      getGlobalSkuFallback('warranty', DEFAULT_WARRANTY_SKU);
    state.warrantySku = sku;
    return sku;
  };

  const getSparkElement = () => document.querySelector(SPARK_SELECTOR);

  const getMainProductQuantityFromSparkTable = () => {
    const spark = getSparkElement();
    const shadow = spark?.shadowRoot;
    if (!shadow) return 1;

    const quantityInputs = shadow.querySelectorAll(QUANTITY_INPUT_SELECTOR);
    let total = 0;
    for (const input of quantityInputs) {
      const qty = parseInt(String(input.value || '0'), 10);
      if (Number.isFinite(qty) && qty >= 1) {
        total += qty;
      }
    }
    return total >= 1 ? total : 1;
  };

  const getMainProductSkuFromSparkTable = () => {
    const spark = getSparkElement();
    const shadow = spark?.shadowRoot;
    if (!shadow) return '';

    const table = shadow.querySelector('.product-variant-table');
    const quantityInputs = shadow.querySelectorAll(QUANTITY_INPUT_SELECTOR);

    for (const input of quantityInputs) {
      const qty = parseInt(String(input.value || '0'), 10);
      if (!Number.isFinite(qty) || qty < 1) continue;

      const row = input.closest('tr');
      if (!row) continue;

      const skuNode = row.querySelector(
        '.product-code.sku [data-spark-sku], .product-code.sku p, .product-code.sku span',
      );
      if (skuNode?.textContent) return skuNode.textContent.trim();
      const rowSku = row.dataset?.sku || row.getAttribute('data-sku') || row.getAttribute('data-variant-sku');
      if (rowSku) return String(rowSku).trim();

      if (table && spark.dataset.stockJsonId) {
        const tbody = table.querySelector('tbody');
        const rows = tbody ? Array.from(tbody.querySelectorAll('tr')) : [];
        const rowIndex = rows.indexOf(row);
        if (rowIndex >= 0) {
          const script = document.getElementById(spark.dataset.stockJsonId);
          if (script?.textContent) {
            try {
              const data = JSON.parse(script.textContent);
              const variants = Array.isArray(data?.variants) ? data.variants : [];
              const variant = variants[rowIndex];
              const sku = variant?.sku;
              if (sku && typeof sku === 'string') return sku.trim();
            } catch (e) {}
          }
        }
      }
    }
    return '';
  };

  const getSparkButton = () => {
    const spark = getSparkElement();
    if (!spark?.shadowRoot) return null;
    return spark.shadowRoot.querySelector(BUTTON_SELECTOR);
  };

  const attachButtonListener = () => {
    const button = getSparkButton();
    if (!button || button.dataset.sparkAddOnAttached === 'true') return;
    button.dataset.sparkAddOnAttached = 'true';
    button.addEventListener('click', handleSparkButtonClick, { passive: true });
  };

  const preventNegativeQuantity = (quantityInput) => {
    if (quantityInput.__negativePreventionApplied) {
      return;
    }

    const validateQuantity = (input) => {
      const value = parseFloat(input.value);
      if (isNaN(value) || value < 1) {
        input.value = '1';
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    };

    quantityInput.setAttribute('min', '1');

    quantityInput.addEventListener('input', function () {
      const value = parseFloat(this.value);
      if (!isNaN(value) && value < 1) {
        this.value = '1';
        this.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    quantityInput.addEventListener('blur', function () {
      validateQuantity(this);
    });

    quantityInput.addEventListener('paste', function () {
      setTimeout(() => {
        validateQuantity(this);
      }, 0);
    });

    quantityInput.addEventListener('keydown', function (e) {
      if (e.key === '-' || e.key === '−' || e.key === 'Minus') {
        e.preventDefault();
        return false;
      }
    });

    quantityInput.__negativePreventionApplied = true;
  };

  const setupQuantityInputs = () => {
    const spark = getSparkElement();
    if (!spark?.shadowRoot) return;

    const quantityInputs = spark.shadowRoot.querySelectorAll(QUANTITY_INPUT_SELECTOR);
    quantityInputs.forEach((input) => {
      preventNegativeQuantity(input);
    });
  };

  const startObservers = () => {
    if (state.observersStarted) return;
    const spark = getSparkElement();
    if (!spark) return;
    state.observersStarted = true;

    const shadow = spark.shadowRoot;
    if (shadow) {
      const observer = new MutationObserver(() => {
        attachButtonListener();
        setupQuantityInputs();
      });
      observer.observe(shadow, {
        childList: true,
        subtree: true,
      });
    }

    new MutationObserver(() => {
      attachButtonListener();
      setupQuantityInputs();
    }).observe(spark, {
      childList: true,
      subtree: true,
    });

    attachButtonListener();
    setupQuantityInputs();
  };

  const getCustomColorAttributes = () => {
    const colorInput = document.getElementById('custom-color-code');
    const code = colorInput?.value?.trim();
    if (!code) return null;

    const productForm = document.querySelector('product-form-component');
    const priceInCents = productForm?.dataset.customColorPrice ? parseInt(productForm.dataset.customColorPrice, 10) : 0;
    const priceInDollars = priceInCents / 100;

    return [
      { key: 'Paint Color Code', value: code },
      { key: 'Non-Refundable Custom Color Fee', value: `$${priceInDollars.toFixed(2)}` },
    ];
  };

  const getCustomColorSkuFromFee = (feeValue) => {
    if (!feeValue) return null;
    const priceMatch = feeValue.match(/\$?([\d.]+)/);
    if (!priceMatch?.[1]) return null;
    const price = parseFloat(priceMatch[1]);
    if (isNaN(price)) return null;
    const priceString = price.toFixed(2).replace(/\.00$/, '').replace(/\.0$/, '');
    return `CCO-${priceString}`;
  };

  const hasWarrantySelected = () => {
    const checkbox = document.getElementById('warranty-checkbox');
    return Boolean(checkbox?.checked);
  };

  const getSelectedAddOnCards = () => {
    const cardsWithClass = Array.from(document.querySelectorAll('.related-products-dropdown .variant-card.selected'));

    return cardsWithClass.map((el) => el);
  };

  const mapCartEntries = (cart) => {
    if (!cart) return [];
    const toArray = (value) => {
      if (!value) return [];
      if (Array.isArray(value)) return value;
      if (typeof value.toArray === 'function') return value.toArray();
      if (typeof value.forEach === 'function') {
        const temp = [];
        value.forEach((item) => temp.push(item));
        return temp;
      }
      if (typeof value[Symbol.iterator] === 'function') {
        return Array.from(value);
      }
      return [];
    };
    const entries = [...toArray(cart.products), ...(!cart.products ? toArray(cart.items) : [])];
    if (!entries.length) return [];
    return entries.map((entry) => ({
      sku: entry?.sku,
      quantity: entry?.quantity,
      customAttributes: entry?.customAttributes,
      itemKey: entry?.itemKey,
      title: entry?.title || entry?.name || '',
    }));
  };

  const fetchCurrentCart = async () => {
    // @ts-ignore
    if (!window.spark?.getCart) return null;
    try {
      // @ts-ignore
      const cart = await window.spark.getCart();
      const products = mapCartEntries(cart);
      return { raw: cart || null, products };
    } catch (error) {
      return null;
    }
  };

  const normalizeQuantity = (value) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
  };

  const hasWarrantyProperty = (product) => {
    if (!product?.customAttributes) return false;
    const warrantyAttr = product.customAttributes.find((attr) => attr?.key === 'This product has opted for warranty');
    return warrantyAttr?.value === 'Yes';
  };

  const hasCustomColorProperty = (product) => {
    if (!product?.customAttributes) return false;
    const paintColorAttr = product.customAttributes.find((attr) => attr?.key === 'Paint Color Code');
    return Boolean(paintColorAttr?.value?.trim());
  };

  const getCustomColorSkuFromProduct = (product) => {
    if (!product?.customAttributes) return null;
    const feeAttr = product.customAttributes.find((attr) => attr?.key === 'Non-Refundable Custom Color Fee');
    return feeAttr?.value ? getCustomColorSkuFromFee(feeAttr.value) : null;
  };

  const getAttr = (product, key) => {
    if (!product?.customAttributes) return null;
    const attr = product.customAttributes.find((a) => a?.key === key);
    return attr?.value?.trim() || null;
  };

  const isCcoItem = (product) => {
    return product?.sku?.startsWith('CCO-') || false;
  };

  const isWarrantyItem = (product, warrantySku) => {
    return product?.sku === warrantySku;
  };

  const isMainProduct = (product, warrantySku) => {
    return !isCcoItem(product) && !isWarrantyItem(product, warrantySku);
  };

  const buildCcoKey = (paintColorCode, associatedProduct) => {
    return `${(paintColorCode || '').trim()}||${(associatedProduct || '').trim()}`;
  };

  const findCcoForMainProduct = (mainProduct, allProducts) => {
    const mainPaintCode = getAttr(mainProduct, 'Paint Color Code');
    if (!mainPaintCode) return null;
    const mainSku = (mainProduct.sku || '').trim();
    const mainKey = buildCcoKey(mainPaintCode, mainSku);

    return (
      allProducts.find((p) => {
        if (!isCcoItem(p)) return false;
        const ccoPaintCode = getAttr(p, 'Paint Color Code');
        const ccoAssociatedSku = getAttr(p, 'Associated Product');
        return buildCcoKey(ccoPaintCode, ccoAssociatedSku) === mainKey;
      }) || null
    );
  };

  const normalizeCustomAttributesForSpark = (attrs) => {
    if (!attrs || !Array.isArray(attrs)) return attrs;
    return attrs
      .map((a) =>
        a && (a.key != null || a.value != null) ? { key: String(a.key ?? ''), value: String(a.value ?? '') } : a,
      )
      .filter(Boolean);
  };

  const updateCart = async (products) => {
    const normalized = Array.isArray(products)
      ? products.map((p) => {
          if (p && p.customAttributes) {
            return { ...p, customAttributes: normalizeCustomAttributesForSpark(p.customAttributes) };
          }
          return p;
        })
      : products;
    try {
      // @ts-ignore
      const spark = window.spark;
      if (!spark || typeof spark.updateCart !== 'function') return false;
      await spark.updateCart({ products: normalized, clearCart: false }, true, true);
      return true;
    } catch (error) {
      return false;
    }
  };

  const UPDATE_CART_READD_DELAY_MS = 350;
  const UPDATE_CART_READD_RETRY_DELAY_MS = 200;

  const updateCartRemoveThenReadd = async (removePayload, readdPayload) => {
    const removed = await updateCart(removePayload);
    if (!removed) return false;
    const delays = [UPDATE_CART_READD_DELAY_MS, UPDATE_CART_READD_RETRY_DELAY_MS, 300];
    for (let i = 0; i < delays.length; i++) {
      await new Promise((r) => setTimeout(r, delays[i]));
      const readdOk = await updateCart(readdPayload);
      if (readdOk) return true;
    }
    return false;
  };

  const handleAddToCart = async () => {
    const items = [];

    const colorAttributes = getCustomColorAttributes();
    if (colorAttributes) {
      const customColorSku = getCustomColorSku();
      const feeAttr = colorAttributes.find((attr) => attr.key === 'Non-Refundable Custom Color Fee');
      const customColorSkuFromFee = feeAttr ? getCustomColorSkuFromFee(feeAttr.value || '') : null;
      const skuToAdd = customColorSkuFromFee || customColorSku;

      const ccoAttributes = [...colorAttributes];
      const mainProductSku = (
        getMainProductSkuFromSparkTable() ||
        (document.querySelector('product-form-component')?.dataset?.currentVariantSku || '').trim() ||
        (document.querySelector('product-form-component')?.dataset?.variantSku || '').trim()
      ).trim();
      if (mainProductSku) {
        ccoAttributes.push({ key: 'Associated Product', value: mainProductSku });
      }

      items.push({
        sku: skuToAdd,
        adjustQuantity: 1,
        customAttributes: ccoAttributes,
      });
    }

    if (hasWarrantySelected()) {
      const warrantySku = getWarrantySku();
      const mainProductQty = getMainProductQuantityFromSparkTable();
      const mainProductSku = (
        getMainProductSkuFromSparkTable() ||
        (document.querySelector('product-form-component')?.dataset?.currentVariantSku || '').trim() ||
        (document.querySelector('product-form-component')?.dataset?.variantSku || '').trim()
      ).trim();
      const warrantyAttributes = [{ key: 'SKU', value: warrantySku }];
      if (mainProductSku) {
        warrantyAttributes.push({ key: 'Associated Product', value: mainProductSku });
      }
      items.push({
        sku: warrantySku,
        adjustQuantity: mainProductQty,
        customAttributes: warrantyAttributes,
      });
    }

    const selectedCards = getSelectedAddOnCards();

    selectedCards.forEach((card) => {
      const variantId = card.dataset.variantId;
      const productId = card.dataset.productId;
      const sku = card.dataset.variantSku;

      if (sku) {
        items.push({
          sku,
          adjustQuantity: 1,
        });
      } else if (variantId && productId) {
        items.push({
          productId,
          variantId,
          adjustQuantity: 1,
        });
      }
    });

    if (items.length > 0) {
      await updateCart(items);
    }

    resetFormElements();
  };

  const buildMainProductQtyMap = (products, warrantySku) => {
    const exactMap = new Map();
    const paintCodeMap = new Map();
    const skuOnlyMap = new Map();

    products.forEach((p) => {
      if (!isMainProduct(p, warrantySku)) return;
      const paintCode = getAttr(p, 'Paint Color Code');
      const qty = normalizeQuantity(p.quantity);
      const sku = (p.sku || '').trim();

      if (paintCode) {
        if (sku) {
          const key = buildCcoKey(paintCode, sku);
          exactMap.set(key, (exactMap.get(key) || 0) + qty);
        }
        paintCodeMap.set(paintCode, (paintCodeMap.get(paintCode) || 0) + qty);
      } else if (sku) {
        skuOnlyMap.set(sku, (skuOnlyMap.get(sku) || 0) + qty);
      }
    });

    return { exactMap, paintCodeMap, skuOnlyMap };
  };

  const lookupMainQty = (ccoPaintCode, ccoAssociatedSku, exactMap, paintCodeMap, skuOnlyMap) => {
    const fullKey = buildCcoKey(ccoPaintCode, ccoAssociatedSku);
    if (exactMap.has(fullKey)) return exactMap.get(fullKey);
    if (ccoAssociatedSku && ccoAssociatedSku.trim() !== '' && skuOnlyMap && skuOnlyMap.has(ccoAssociatedSku)) {
      return skuOnlyMap.get(ccoAssociatedSku);
    }
    if (ccoAssociatedSku && ccoAssociatedSku.trim() !== '') return undefined;
    if (paintCodeMap.has(ccoPaintCode)) return paintCodeMap.get(ccoPaintCode);
    return undefined;
  };

  const syncCcoQuantities = async (currentProducts) => {
    const warrantySku = getWarrantySku();
    const updates = [];

    const { exactMap, paintCodeMap, skuOnlyMap } = buildMainProductQtyMap(currentProducts, warrantySku);

    currentProducts.forEach((p) => {
      if (!isCcoItem(p)) return;
      const ccoPaintCode = getAttr(p, 'Paint Color Code');
      const ccoAssociatedSku = getAttr(p, 'Associated Product');
      if (!ccoPaintCode) return;

      const expectedQty = lookupMainQty(ccoPaintCode, ccoAssociatedSku, exactMap, paintCodeMap, skuOnlyMap);
      const currentQty = normalizeQuantity(p.quantity);

      if (expectedQty !== undefined && expectedQty > 0) {
        const diff = expectedQty - currentQty;
        if (diff !== 0 && p.itemKey) {
          updates.push({ itemKey: p.itemKey, adjustQuantity: diff });
        }
      } else if (ccoAssociatedSku && ccoAssociatedSku.trim() !== '') {
        if (currentQty > 0 && p.itemKey) {
          updates.push({ itemKey: p.itemKey, adjustQuantity: -currentQty });
        }
      }
    });

    if (updates.length > 0) {
      await updateCart(updates);
    }
  };

  const handleCcoRemovalReverseSync = async (previousProducts, currentProducts) => {
    const warrantySku = getWarrantySku();
    const previousCcoItems = previousProducts.filter((p) => isCcoItem(p));
    const currentCcoItems = currentProducts.filter((p) => isCcoItem(p));

    let checkoutWasDisabled = false;

    for (const prevCco of previousCcoItems) {
      const prevPaintCode = getAttr(prevCco, 'Paint Color Code');
      if (!prevPaintCode) continue;

      const prevAssociated = getAttr(prevCco, 'Associated Product');
      const prevKey = buildCcoKey(prevPaintCode, prevAssociated);

      const stillExists = currentCcoItems.some((curr) => {
        const currPaintCode = getAttr(curr, 'Paint Color Code');
        const currAssociated = getAttr(curr, 'Associated Product');
        return buildCcoKey(currPaintCode, currAssociated) === prevKey;
      });

      if (!stillExists) {
        if (!checkoutWasDisabled) {
          disableCheckoutButton();
          scheduleCheckoutReenableFallback();
          checkoutWasDisabled = true;
          setTimeout(() => {
            if (checkoutDisabledForCcoSync) {
              const btn = getCheckoutButton();
              if (btn) {
                btn.disabled = true;
                btn.setAttribute('aria-busy', 'true');
              }
            }
          }, CHECKOUT_REAPPLY_DISABLE_MS);
        }

        const mainProducts = currentProducts.filter((p) => {
          if (!isMainProduct(p, warrantySku)) return false;
          const mainPaintCode = getAttr(p, 'Paint Color Code');
          if (!mainPaintCode || mainPaintCode !== prevPaintCode) return false;
          if (!getAttr(p, 'Non-Refundable Custom Color Fee')) return false;
          const mainSku = (p.sku || '').trim();
          if (prevAssociated && mainSku !== prevAssociated) return false;
          return true;
        });

        for (const main of mainProducts) {
          if (!main.itemKey) continue;
          const mainQty = normalizeQuantity(main.quantity);
          if (mainQty <= 0) continue;

          const newAttrs = (main.customAttributes || []).filter(
            (a) => a.key !== 'Paint Color Code' && a.key !== 'Non-Refundable Custom Color Fee',
          );

          await updateCartRemoveThenReadd(
            [{ itemKey: main.itemKey, adjustQuantity: -mainQty }],
            [
              {
                sku: main.sku,
                adjustQuantity: mainQty,
                customAttributes: newAttrs,
              },
            ],
          );
        }
      }
    }

    if (checkoutWasDisabled) {
      reenableCheckoutButton();
    }
  };

  const getWarrantyLineQty = (products, warrantySku) => {
    const warrantyItem = products.find((p) => isWarrantyItem(p, warrantySku));
    return warrantyItem ? normalizeQuantity(warrantyItem.quantity) : 0;
  };

  /** Returns all warranty items with itemKey, quantity, associatedProduct (like theme getWarrantyLineItems). */
  const getWarrantyItems = (products, warrantySku) => {
    if (!products || !Array.isArray(products)) return [];
    return products
      .filter((p) => isWarrantyItem(p, warrantySku))
      .map((p) => ({
        itemKey: p.itemKey,
        quantity: normalizeQuantity(p.quantity),
        associatedProduct: getAttr(p, 'Associated Product') || '',
      }));
  };

  /** Build map of main product SKU -> total quantity that has warranty (for reduction per SKU). */
  const getWarrantedMainQtyBySku = (products, warrantySku) => {
    const map = new Map();
    if (!products || !Array.isArray(products)) return map;
    products.forEach((p) => {
      if (!isMainProduct(p, warrantySku) || !hasWarrantyProperty(p)) return;
      const sku = (p.sku || '').trim();
      if (!sku) return;
      map.set(sku, (map.get(sku) || 0) + normalizeQuantity(p.quantity));
    });
    return map;
  };

  const handleWarrantyRemovalReverseSync = async (previousProducts, currentProducts) => {
    const warrantySku = getWarrantySku();
    const previousWarrantyItems = getWarrantyItems(previousProducts, warrantySku);
    const currentWarrantyItems = getWarrantyItems(currentProducts, warrantySku);

    const toRemoveFromMain = [];
    for (const prev of previousWarrantyItems) {
      if (!prev.associatedProduct) continue;
      const curr = currentWarrantyItems.find((w) => w.associatedProduct === prev.associatedProduct);
      const currQty = curr ? curr.quantity : 0;
      if (currQty === 0 && prev.quantity > 0) {
        toRemoveFromMain.push(prev.associatedProduct);
      }
    }

    if (toRemoveFromMain.length === 0) return;

    let checkoutWasDisabled = false;
    disableCheckoutButton();
    scheduleCheckoutReenableFallback();
    checkoutWasDisabled = true;
    setTimeout(() => {
      if (checkoutDisabledForCcoSync) {
        const btn = getCheckoutButton();
        if (btn) {
          btn.disabled = true;
          btn.setAttribute('aria-busy', 'true');
        }
      }
    }, CHECKOUT_REAPPLY_DISABLE_MS);

    for (const associatedSku of toRemoveFromMain) {
      const main = currentProducts.find((p) => {
        if (!isMainProduct(p, warrantySku)) return false;
        if (!hasWarrantyProperty(p)) return false;
        return (p.sku || '').trim() === associatedSku.trim();
      });
      if (!main?.itemKey) continue;

      const mainQty = normalizeQuantity(main.quantity);
      if (mainQty <= 0) continue;

      const newAttrs = (main.customAttributes || []).filter((a) => a.key !== 'This product has opted for warranty');

      await updateCartRemoveThenReadd(
        [{ itemKey: main.itemKey, adjustQuantity: -mainQty }],
        [
          {
            sku: main.sku,
            adjustQuantity: mainQty,
            customAttributes: newAttrs,
          },
        ],
      );
    }

    if (checkoutWasDisabled) {
      reenableCheckoutButton();
    }
  };

  const syncWarrantyQuantity = async (previousProducts, currentProducts) => {
    const warrantySku = getWarrantySku();
    const currWarrantedBySku = getWarrantedMainQtyBySku(currentProducts, warrantySku);
    const warrantyItems = getWarrantyItems(currentProducts, warrantySku);

    for (const w of warrantyItems) {
      const associatedSku = (w.associatedProduct || '').trim();
      if (!associatedSku || !w.itemKey) continue;
      const expectedQty = currWarrantedBySku.get(associatedSku) ?? 0;
      const currentQty = w.quantity;
      if (currentQty === expectedQty) continue;
      const diff = expectedQty - currentQty;
      await updateCart([{ itemKey: w.itemKey, adjustQuantity: diff }]);
    }
  };

  const getMainProductSkusInCart = (products, warrantySku) => {
    if (!products || !Array.isArray(products)) return new Set();
    const skus = new Set();
    products.forEach((p) => {
      if (!isMainProduct(p, warrantySku)) return;
      const sku = (p.sku || '').trim();
      if (sku) skus.add(sku);
    });
    return skus;
  };

  const clearOrphanedWarrantyAssociatedProduct = async (currentProducts) => {
    if (!currentProducts || !currentProducts.length) return;

    const warrantySku = getWarrantySku();
    const mainProductSkus = getMainProductSkusInCart(currentProducts, warrantySku);
    const warrantyItems = currentProducts.filter((p) => isWarrantyItem(p, warrantySku));

    for (const warrantyItem of warrantyItems) {
      // @ts-ignore
      if (!window.spark?.updateCart) return;
      if (!warrantyItem?.itemKey || !warrantyItem.customAttributes) continue;
      const associatedSku = (getAttr(warrantyItem, 'Associated Product') || '').trim();
      if (!associatedSku || mainProductSkus.has(associatedSku)) continue;

      const qty = normalizeQuantity(warrantyItem.quantity);
      if (qty <= 0) continue;

      // Only remove the orphaned warranty line. Do not re-add (Spark's updateCart throws after
      // the first update in this flow, even with other products in cart).
      try {
        await updateCart([{ itemKey: warrantyItem.itemKey, adjustQuantity: -qty }]);
      } catch (e) {
        break;
      }
    }
  };

  let isSyncing = false;

  const handleCartSync = async () => {
    if (isSyncing) return;
    isSyncing = true;

    try {
      const currentCart = await fetchCurrentCart();
      if (!currentCart?.products) {
        state.previousCartProducts = null;
        return;
      }

      const currentProducts = currentCart.products;
      const previousProducts = state.previousCartProducts;

      if (!previousProducts || previousProducts.length === 0) {
        state.previousCartProducts = currentProducts;
        return;
      }

      if (currentProducts.length === 0 && previousProducts.length === 0) {
        return;
      }

      await syncCcoQuantities(currentProducts);
      await handleCcoRemovalReverseSync(previousProducts, currentProducts);
      await handleWarrantyRemovalReverseSync(previousProducts, currentProducts);
      await clearOrphanedWarrantyAssociatedProduct(currentProducts);
      await syncWarrantyQuantity(previousProducts, currentProducts);

      const freshCart = await fetchCurrentCart();
      const freshProducts = freshCart?.products || currentProducts;
      state.previousCartProducts = freshProducts;
      lastCartHash = getCartHash(freshProducts);
    } finally {
      isSyncing = false;
    }
  };

  const resetFormElements = () => {
    const warrantyCheckbox = document.getElementById('warranty-checkbox');
    const warrantyOption = document.querySelector('.warranty-option');
    if (warrantyCheckbox?.checked) {
      warrantyCheckbox.checked = false;
      warrantyOption?.classList.remove('selected');
    }

    getSelectedAddOnCards().forEach((card) => card.classList.remove('selected'));

    const colorInput = document.getElementById('custom-color-code');
    if (colorInput?.value) {
      colorInput.value = '';
    }

    const colorHeader = document.querySelector('.custom-color-option__header');
    const colorContent = document.querySelector('.custom-color-option__content');
    if (colorContent?.classList.contains('open')) {
      colorContent.classList.remove('open');
      colorHeader?.classList.remove('active');
    }
  };

  const handleSparkButtonClick = async () => {
    queue.add(async () => {
      await new Promise((resolve) => setTimeout(resolve, 300));

      await handleAddToCart();

      const finalCart = await fetchCurrentCart();
      if (finalCart?.products) {
        state.previousCartProducts = finalCart.products;
      }
    });
  };

  let cartPollInterval = null;
  let lastCartHash = null;

  const getCartHash = (products) => {
    if (!products || !Array.isArray(products)) return '';
    return products
      .map((p) => {
        const attrHash = (p.customAttributes || [])
          .map((a) => `${a.key}=${a.value}`)
          .sort()
          .join('&');
        return `${p.itemKey || ''}:${p.sku}:${p.quantity}:${attrHash}`;
      })
      .sort()
      .join('|');
  };

  const startCartPolling = async () => {
    if (cartPollInterval) {
      return;
    }

    const cart = await fetchCurrentCart();
    if (cart?.products) {
      lastCartHash = getCartHash(cart.products);
      const hasCcoItems = cart.products.some((p) => isCcoItem(p));
      if (hasCcoItems && !state.previousCartProducts?.length) {
        state.previousCartProducts = cart.products;
      }
    }

    cartPollInterval = setInterval(async () => {
      const sparkDrawer = document.querySelector('spark-drawer');
      if (!sparkDrawer || !sparkDrawer.hasAttribute('open')) {
        return;
      }

      const currentCart = await fetchCurrentCart();
      if (!currentCart?.products) {
        return;
      }

      const currentHash = getCartHash(currentCart.products);

      if (lastCartHash && lastCartHash !== currentHash) {
        queue.add(async () => {
          await new Promise((resolve) => setTimeout(resolve, 200));
          await handleCartSync();
          disableCcoQuantityControls();
          requestAnimationFrame(disableCcoQuantityControls);
        });
      }
      lastCartHash = currentHash;
    }, 500);
  };

  const stopCartPolling = () => {
    if (cartPollInterval) {
      clearInterval(cartPollInterval);
      cartPollInterval = null;
    }
  };

  const injectCcoStyles = (shadowRoot) => {
    if (!shadowRoot || shadowRoot.getElementById('cco-disable-styles')) return;
    const style = document.createElement('style');
    style.id = 'cco-disable-styles';
    style.textContent = `
      [data-cco-item="true"] input[type="number"],
      [data-warranty-item="true"] input[type="number"] {
        pointer-events: none !important;
        opacity: 0.5 !important;
        cursor: not-allowed !important;
      }
      [data-cco-item="true"] button:has(svg-minus),
      [data-cco-item="true"] button:has(svg-plus),
      [data-warranty-item="true"] button:has(svg-minus),
      [data-warranty-item="true"] button:has(svg-plus) {
        pointer-events: none !important;
        opacity: 0.5 !important;
        cursor: not-allowed !important;
      }
    `;
    shadowRoot.appendChild(style);
  };

  const markCcoItems = (shadowRoot) => {
    if (!shadowRoot) return;

    const walker = document.createTreeWalker(shadowRoot, NodeFilter.SHOW_TEXT, {
      acceptNode: (node) => {
        return /CCO-[\d.]+/.test(node.textContent || '') ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      },
    });

    const ccoContainers = new Set();
    while (walker.nextNode()) {
      const textNode = walker.currentNode;
      let el = textNode.parentElement;

      while (el && el !== shadowRoot) {
        if (el.querySelector && el.querySelector('input[type="number"]')) {
          ccoContainers.add(el);
          break;
        }
        el = el.parentElement;
      }
    }

    ccoContainers.forEach((container) => {
      if (container.getAttribute('data-cco-item') !== 'true') {
        container.setAttribute('data-cco-item', 'true');

        const inputs = container.querySelectorAll('input[type="number"]');
        inputs.forEach((input) => {
          input.disabled = true;
          input.setAttribute('readonly', 'true');
        });

        const buttons = container.querySelectorAll('button');
        buttons.forEach((btn) => {
          if (btn.querySelector('svg-minus, svg-plus')) {
            btn.disabled = true;
          }
        });
      }
    });
  };

  const markWarrantyItems = (shadowRoot) => {
    if (!shadowRoot) return;

    const warrantySku = getWarrantySku();
    if (!warrantySku || typeof warrantySku !== 'string') return;

    const skuTrimmed = warrantySku.trim();
    if (!skuTrimmed) return;

    const walker = document.createTreeWalker(shadowRoot, NodeFilter.SHOW_TEXT, {
      acceptNode: (node) => {
        const text = node.textContent || '';
        return text.includes(skuTrimmed) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      },
    });

    const warrantyContainers = new Set();
    while (walker.nextNode()) {
      const textNode = walker.currentNode;
      let el = textNode.parentElement;

      while (el && el !== shadowRoot) {
        if (el.querySelector && el.querySelector('input[type="number"]')) {
          warrantyContainers.add(el);
          break;
        }
        el = el.parentElement;
      }
    }

    warrantyContainers.forEach((container) => {
      if (container.getAttribute('data-warranty-item') !== 'true') {
        container.setAttribute('data-warranty-item', 'true');

        const inputs = container.querySelectorAll('input[type="number"]');
        inputs.forEach((input) => {
          input.disabled = true;
          input.setAttribute('readonly', 'true');
        });

        const buttons = container.querySelectorAll('button');
        buttons.forEach((btn) => {
          if (btn.querySelector('svg-minus, svg-plus')) {
            btn.disabled = true;
          }
        });
      }
    });
  };

  const disableCcoQuantityControls = () => {
    const sparkDrawer = document.querySelector('spark-drawer');
    if (!sparkDrawer?.shadowRoot) return;

    injectCcoStyles(sparkDrawer.shadowRoot);
    markCcoItems(sparkDrawer.shadowRoot);
    markWarrantyItems(sparkDrawer.shadowRoot);
  };

  let drawerShadowObserverSetup = false;

  const observeSparkDrawerShadow = () => {
    if (drawerShadowObserverSetup) return;
    const sparkDrawer = document.querySelector('spark-drawer');
    if (!sparkDrawer) return;

    const setupObserver = () => {
      if (!sparkDrawer.shadowRoot) return false;
      drawerShadowObserverSetup = true;

      const observer = new MutationObserver((mutations) => {
        const hasChildListChanges = mutations.some((m) => m.type === 'childList');
        if (hasChildListChanges) {
          disableCcoQuantityControls();
          requestAnimationFrame(disableCcoQuantityControls);
        }
      });
      observer.observe(sparkDrawer.shadowRoot, {
        childList: true,
        subtree: true,
      });
      disableCcoQuantityControls();
      return true;
    };

    if (!setupObserver()) {
      let attempts = 0;
      const maxAttempts = 80;
      const interval = setInterval(() => {
        attempts++;
        if (setupObserver() || attempts >= maxAttempts) {
          clearInterval(interval);
        }
      }, 50);
    }
  };

  const observeSparkDrawer = () => {
    const sparkDrawer = document.querySelector('spark-drawer');
    if (!sparkDrawer) {
      return;
    }

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          if (sparkDrawer.hasAttribute('open')) {
            startCartPolling();
            disableCcoQuantityControls();
            requestAnimationFrame(disableCcoQuantityControls);
            setTimeout(disableCcoQuantityControls, 0);
            setTimeout(disableCcoQuantityControls, 50);
            setTimeout(disableCcoQuantityControls, 100);
            setTimeout(disableCcoQuantityControls, 200);
            setTimeout(disableCcoQuantityControls, 400);
          } else {
            stopCartPolling();
          }
        }
      });
    });

    observer.observe(sparkDrawer, {
      attributes: true,
      attributeFilter: ['open'],
    });

    if (sparkDrawer.hasAttribute('open')) {
      startCartPolling();
      disableCcoQuantityControls();
      requestAnimationFrame(disableCcoQuantityControls);
      setTimeout(disableCcoQuantityControls, 0);
      setTimeout(disableCcoQuantityControls, 50);
      setTimeout(disableCcoQuantityControls, 100);
      setTimeout(disableCcoQuantityControls, 200);
      setTimeout(disableCcoQuantityControls, 400);
    }
  };

  // @ts-ignore
  window.__sparkAddOnSyncHandleRemove = () => {
    queue.add(async () => {
      disableCcoQuantityControls();
      await new Promise((resolve) => setTimeout(resolve, 200));
      await handleCartSync();
      disableCcoQuantityControls();
      requestAnimationFrame(disableCcoQuantityControls);
    });
  };

  const boot = async () => {
    if (!state.initialized) {
      const initialCart = await fetchCurrentCart();
      if (initialCart?.products) {
        state.previousCartProducts = initialCart.products;
      }
      state.initialized = true;
    }

    const sparkElement = getSparkElement();

    let drawerSetupAttempted = false;
    const setupDrawerObservation = () => {
      if (drawerSetupAttempted) return false;
      const sparkDrawer = document.querySelector('spark-drawer');
      if (sparkDrawer) {
        drawerSetupAttempted = true;
        observeSparkDrawer();
        observeSparkDrawerShadow();
        return true;
      }
      return false;
    };

    if (!setupDrawerObservation()) {
      let checkCount = 0;
      const maxChecks = 50;
      const drawerObserver = new MutationObserver(() => {
        checkCount++;
        if (setupDrawerObservation() || checkCount >= maxChecks) {
          drawerObserver.disconnect();
        }
      });
      drawerObserver.observe(document.body, {
        childList: true,
        subtree: true,
      });

      setTimeout(() => {
        drawerObserver.disconnect();
        drawerSetupAttempted = true;
      }, 5000);
    }

    if (!sparkElement) return;
    attachButtonListener();
    startObservers();
  };

  const tryBoot = () => {
    const spark = getSparkElement();
    if (spark?.shadowRoot) {
      boot();
      return true;
    }
    boot();
    return false;
  };

  if (tryBoot()) {
    document.addEventListener('spark:variants:updated', () => {
      attachButtonListener();
      setupQuantityInputs();
    });
  } else {
    document.addEventListener('spark:ready', boot, { once: true });
    document.addEventListener('spark:variants:updated', () => {
      attachButtonListener();
      setupQuantityInputs();
    });

    let checkCount = 0;
    const maxChecks = 20;
    const checkInterval = setInterval(() => {
      checkCount++;
      if (tryBoot() || checkCount >= maxChecks) {
        clearInterval(checkInterval);
      }
    }, 250);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tryBoot);
    }

    if (document.readyState !== 'complete') {
      window.addEventListener('load', tryBoot, { once: true });
    }
  }
})();
